"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _DmsModalHeader = require("./DmsModalHeader");
var _DmsModalBody = require("./DmsModalBody");
var _DmsModalFooter = require("./DmsModalFooter");
const _excluded = ["isVisible", "onClose", "children", "closeWithIconOnly", "showCloseIcon"]; // DmsModal.js
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * DmsModal component
 * 
 * @param {object} props - Component props
 * @param {boolean} props.isVisible - Controls the visibility of the modal
 * @param {function} props.onClose - Function to call when the modal should be closed
 * @param {React.ReactNode} props.children - Children elements to render in the modal
 * @param {boolean} [props.closeWithIconOnly] - If true, only the close button will close the modal
 * @param {boolean} [props.showCloseIcon] - Determines whether the close (X) button should be displayed
 * @returns {JSX.Element} The rendered modal component
 */
const DmsModal = _ref => {
  let {
      isVisible,
      onClose,
      children,
      closeWithIconOnly = false,
      showCloseIcon = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const childArray = _react.default.Children.toArray(children);
  const header = childArray.find(child => (child === null || child === void 0 ? void 0 : child.type) === _DmsModalHeader.DmsModalHeader);
  const body = childArray.filter(child => (child === null || child === void 0 ? void 0 : child.type) !== _DmsModalHeader.DmsModalHeader);
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, _extends({
    open: isVisible,
    onClose: !closeWithIconOnly ? onClose : undefined
  }, props), header && /*#__PURE__*/_react.default.cloneElement(header, {
    onClose: onClose || (() => {}),
    showCloseIcon
  }), body);
};
exports.DmsModal = DmsModal;
DmsModal.propTypes = {
  isVisible: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired,
  closeWithIconOnly: _propTypes.default.bool,
  showCloseIcon: _propTypes.default.bool
};
DmsModal.Header = _DmsModalHeader.DmsModalHeader;
DmsModal.Body = _DmsModalBody.DmsModalBody;
DmsModal.Footer = _DmsModalFooter.DmsModalFooter;